import { faBell, faCalendarWeek, faClapperboardPlay, faMapLocation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import { FunctionalComponent } from 'preact';
import { useRef } from 'preact/hooks';
import { getCurrentUrl, Link } from 'preact-router';
import { useDispatch } from 'react-redux';

import { setMembersOnlyWarningModalState } from '@/components/MembersOnlyWarningModal/redux/actions';
import RoundCount from '@/components/RoundCount';
import { useUnreadAnnouncementsCount } from '@/hooks/announcements';
import { useShouldBellRing } from '@/hooks/notifications';
import { getUnreadNotificationCountQueryOption } from '@/queries/notifications';
import { useSelector } from '@/redux/helper';

import style from './style.scss';

const activeClass = (path: string) => (getCurrentUrl().includes(path) ? style.active : undefined);

const MobileTabs: FunctionalComponent = () => {
  const { data: unreadAnnouncements } = useUnreadAnnouncementsCount();
  const dispatch = useDispatch();
  const logged = useSelector((state) => state.user.logged);
  const { data: unreadNotifications } = useQuery({
    ...getUnreadNotificationCountQueryOption(),
    enabled: !!logged,
  });
  const bellRef = useRef<HTMLDivElement>(null);
  const unread = (unreadAnnouncements ?? 0) + (unreadNotifications ?? 0);
  const shouldBellRing = useShouldBellRing(unread, bellRef);

  const NotificationsContent = (
    <div className="relative">
      <div
        ref={bellRef}
        className={unread > 0 && shouldBellRing ? 'animate-[ringingBell_2s_1s_ease-in-out] [transform-origin:50%_0]' : ''}
      >
        <FontAwesomeIcon icon={faBell} />
      </div>
      {unread > 0 && <RoundCount count={unread} className="bg-text-error-red" />}
    </div>
  );

  return (
    <nav className={style.mobileTabs}>
      <ul>
        <li>
          <Link className={activeClass('/highlights')} href="/highlights">
            <FontAwesomeIcon icon={faClapperboardPlay} />
          </Link>
        </li>
        <li>
          <Link className={activeClass('/home')} href="/home">
            <FontAwesomeIcon icon={faMapLocation} />
          </Link>
        </li>
        <li>
          <Link className={activeClass('schedule')} href="/schedule">
            <div className="relative">
              <FontAwesomeIcon icon={faCalendarWeek} />
            </div>
          </Link>
        </li>
        <li>
          {logged ? (
            <Link className={activeClass('/notifications')} href="/notifications">
              {NotificationsContent}
            </Link>
          ) : (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              className={activeClass('/notifications')}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                dispatch(setMembersOnlyWarningModalState({ type: 'guest-general', redirectOnDismiss: false }));
              }}
              aria-label="Notifications"
            >
              {NotificationsContent}
            </a>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default MobileTabs;
